/**
 * Incorporation (Pre) — Section 201 인스턴스(선임 이사별) 컨텍스트.
 *   CDD 와 동일 패턴: 각 인스턴스 = { docType(declaration/attestation), values(s201_name/s201_nric) }.
 *   기본은 이사별 Declaration(Without Attestation) 자동생성 + 수동 Add(Declaration / With Attestation).
 */
import type { InjectionKey, Ref } from 'vue';

export type S201DocType = 'declaration' | 'attestation';

export interface S201Instance {
  id: number;
  docType: S201DocType;
  label: string;
  values: Record<string, string>; // s201_name, s201_nric (인스턴스별). company_name/declaration_date 는 공유.
}

export interface IncPreS201Ctx {
  docs: Ref<S201Instance[]>;
  activeId: Ref<number>;
  select: (id: number) => void;
  add: (docType: S201DocType) => void;
  remove: (id: number) => void;
}

export const INC_PRE_S201: InjectionKey<IncPreS201Ctx> = Symbol('incPreS201');

export const S201_TYPE_META: Record<S201DocType, { label: string; icon: string }> = {
  declaration: { label: 'Declaration (Without Attestation)', icon: 'mdi-file-document-outline' },
  attestation: { label: 'Declaration (With Attestation)', icon: 'mdi-scale-balance' },
};
